/**
 * 관리자 인증 서비스
 */

import { apiClient } from '../../../shared/services/api';
import { LoginRequest, LoginResponse } from '../types';

export const authService = {
  /**
   * 로그인
   */
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    try {
      const response = await apiClient.post<{ data: LoginResponse }>('/admin/login', credentials);
      return response.data;
    } catch (error: any) {
      if (error.response?.data?.error?.message) {
        throw new Error(error.response.data.error.message);
      }
      throw new Error('로그인에 실패했습니다. 다시 시도해주세요.');
    }
  },

  /**
   * 로그아웃
   */
  logout: async (): Promise<void> => {
    // 로컬 스토리지에서 토큰 제거
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  },

  /**
   * 액세스 토큰 저장
   */
  saveTokens: (accessToken: string, refreshToken: string, user: any): void => {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', JSON.stringify(user));
  },

  /**
   * 저장된 토큰 가져오기
   */
  getStoredTokens: () => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;

    return { accessToken, refreshToken, user };
  },

  /**
   * 인증 상태 확인
   */
  isAuthenticated: (): boolean => {
    const { accessToken } = authService.getStoredTokens();
    return !!accessToken;
  },

  /**
   * 토큰 갱신
   */
  refreshAccessToken: async (): Promise<{ accessToken: string; refreshToken: string }> => {
    const { refreshToken } = authService.getStoredTokens();
    if (!refreshToken) {
      throw new Error('Refresh token not found');
    }

    // 실제 API 호출
    const response = await apiClient.post<{ data: { accessToken: string; refreshToken: string } }>(
      '/admin/refresh',
      { refreshToken }
    );

    return response.data;
  },
};
